import { ITypeaheadService } from './typeahead-service';

export enum MultiFilterType {
  CheckboxList = 'checkbox-list',
  RadioButtonList = 'radio-button-list',
  LocationTypeahead = 'location-typeahead',
  PositionTypeahead = 'position-typeahead',
  TextInput = 'text-input',
  DateRange = 'date-range',
}
export interface SelectableOption {
  label: string;
  value: any;
}

export interface DatePreset {
  label: string;
  start: Date;
  end: Date;
}

export interface IMultiFilter {
  id: string; // Unique id for the filter
  headingText: string; // Heading text to be displayed in labels
  type: MultiFilterType; // Type of filter to render
  isExpanded: boolean; // initial state of being expanded
}

export interface DateRangeSelection {
  start: Date;
  end: Date;
}

export interface ICheckboxListFilter extends IMultiFilter {
  options: SelectableOption[];
}

export interface IRadioButtonListFilter extends IMultiFilter {
  options: SelectableOption[];
  defaultOption: SelectableOption;
}

export interface ITextInputFilter extends IMultiFilter {
  inputLabel: string;
  inputHint?: string;
}

export interface IDateRangeFilter extends IMultiFilter {
  presetDates: DatePreset[];
}

export interface ITypeaheadFilter extends IMultiFilter {
  typeaheadService: ITypeaheadService;
}

export interface ITypeaheadFilterControl {
  label: string;
  value: any;
  isSelected: boolean;
  isHidden?: boolean;
  bottomTextLeft?: string;
  bottomTextRight?: string;
}
